export default "/images/c7bec0ef29c2ca101d270cfd744854c6.avif";